import React from 'react';
import { Box, Typography, Divider, TextField, MenuItem, Button, Table, TableHead, TableBody, TableRow, TableCell, Chip } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DownloadIcon from '@mui/icons-material/Download';

const EditEmployeeDocuments = ({ 
  documents, docTypes, uploadType, setUploadType, uploadFile, setUploadFile, handleDocumentUpload 
}) => {
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 3 }}>Document Vault</Typography>
      <Divider sx={{ mb: 3 }} />
      <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center', p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
        <TextField select size="small" label="Document Category" value={uploadType} onChange={e => setUploadType(e.target.value)} sx={{ minWidth: 200, width: '100%' }} SelectProps={{ displayEmpty: true }} InputLabelProps={{ shrink: true }}>
          <MenuItem value=""><em>Select Type</em></MenuItem>
          {docTypes.map(dt => <MenuItem key={dt.id} value={dt.name}>{dt.name}</MenuItem>)}
        </TextField>
        <Button component="label" variant="contained" startIcon={<UploadFileIcon />}>
          Choose File <input type="file" hidden onChange={e => setUploadFile(e.target.files[0])} />
        </Button>
        {uploadFile && <Typography variant="body2" color="primary">{uploadFile.name}</Typography>}
        {uploadFile && <Button variant="contained" color="success" onClick={handleDocumentUpload}>Upload</Button>}
      </Box>
      
      <Table size="small">
        <TableHead sx={{ bgcolor: '#e0e0e0' }}>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documents.length === 0 ? <TableRow><TableCell colSpan={4} align="center">No documents uploaded.</TableCell></TableRow> :
            documents.map(doc => (
              <TableRow key={doc.id}>
                <TableCell sx={{ fontWeight: 'bold' }}>{doc.document_type}</TableCell>
                <TableCell>{new Date(doc.upload_date || new Date()).toLocaleDateString()}</TableCell>
                <TableCell><Chip size="small" label={doc.status} color={doc.status === 'APPROVED' ? 'success' : (doc.status === 'REJECTED' ? 'error' : 'warning')} /></TableCell>
                <TableCell align="right">
                  <Button size="small" startIcon={<DownloadIcon />} onClick={() => window.open(`/api/v1/employees/documents/${doc.id}/download`, '_blank')}>View</Button>
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </Box>
  );
};

export default EditEmployeeDocuments;